import styled, { css } from 'styled-components';
import { Link, NavLink as RawNavLink } from 'react-router-dom';
import { InlineList, List, media, NavLink, size, spacing } from './';

export const Tabs = styled(InlineList)`
   box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.separator};
   margin-bottom: ${spacing(2)};
   display: flex;
   align-items: center;
   width: 100%;

   ${props =>
      props.hasLittleMargin &&
      css`
         margin-bottom: ${spacing()};
      `};

   ${props =>
      props.shouldBeHiddenOnSmallViewports &&
      css`
         display: none;

         ${media.tablet`
        display: flex;
      `};
      `};
`;

export const Tab = styled.li`
   + li {
      margin-left: ${spacing()};
   }

   ${props =>
      props.right &&
      css`
         display: flex;
         align-items: center;
         justify-content: flex-end;
         height: 100%;
         flex: 1;
      `};
`;

export const TabNavLink = styled(NavLink)`
   color: inherit;
   display: inline-block;
   padding-top: ${spacing(0.75)};
   padding-bottom: ${spacing(0.75)};
   font-size: ${size()};
   font-weight: 600;
   color: ${({ theme }) => theme.textLight};
   text-decoration: none;

   &:hover,
   &.active {
      color: ${({ theme }) => theme.primary};
   }

   &.active {
      box-shadow: inset 0 -2px 0 0 currentColor;
   }
`;

export const TabLink = TabNavLink.withComponent(Link);

export const MainTabNavLink = styled(RawNavLink)`
   text-decoration: none;
   font-size: 16px;
   font-weight: 600;
   text-align: center;
   color: rgba(0, 0, 0, 0.6);
   padding-top: ${spacing()};
   padding-bottom: ${spacing()};
   display: flex;
   align-items: center;

   &:hover,
   &.active {
      color: ${({ theme }) => theme.primary};
   }

   &.active {
      box-shadow: inset 0 -3px 0 0 ${({ theme }) => theme.primary};
   }

   ${media.tablet`
    padding-top: ${spacing(0.75)};
    padding-bottom: ${spacing(0.75)};
  `};
`;

export const MainTab = styled.li`
   display: flex;
   align-items: center;
   white-space: nowrap;

   + li {
      margin-left: ${spacing()};
   }
`;

export const MainTabs = styled(List)`
   display: flex;
   flex: 1;
   background-color: #fff;
   align-items: center;
   margin: ${spacing(-1)} ${spacing(-1)} ${spacing()};
   padding-left: ${spacing()};
   padding-right: ${spacing()};
   box-shadow: inset 0 -1px 0 0 ${({ theme }) => theme.separator};

   ${media.tablet`
    display: flex;
    background-color: transparent;
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
    padding-left: 0;
    padding-right: 0;
  `};
`;
